export default {
  previousPage: '上一页',
  nextPage: '下一页',
  goTo: '前往',
  page: '页',
  confirm: '确定'
}
